module.exports = ".margin-top {\r\n    margin-top: 25px;\r\n}\r\n.table th, .table td {\r\n    padding: 0.75rem;\r\n    vertical-align: top;\r\n     border-top: 0px solid #eceeef;\r\n}\r\n.tspan{\r\n    color: #333333;\r\n    font-size: 18px;\r\n    fill: #333333;\r\n    font-weight: 500;\r\n}\r\n.custom-height{\r\n    height: 440px!important\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/dashboard.component.css
// module id = ./src/app/modules/dashboard/dashboard.component.css
// module chunks = main